<template>
    <Spinner v-if="isLoading" />

<div class="paymetPlaceholder grid">
    <div class="col-12 totalValue">        
        <div class="amountlabel">Iznos za plaćanje:</div>                
        <div class="amountnumber">{{ formatCurrency(bankAmount) }}</div>
    </div>

    <div class="col-12">        
        <div class="checkPay"><Checkbox v-model="checkedUslovi" :binary="true" /></div>
        <div>Pročitao/la sam i prihvatam Opšte uslove poslovanja E-laboratorije. * <a href="https://www.biomedicazavod.rs/uslovi-koriscenja" target="_blank">{{ translated('clicktoview') }}</a></div>                
    </div>

    <div class="col-12">
        <div class="checkPay"><Checkbox v-model="checkedPrivatnost" :binary="true" /></div>
        <div>Pročitao/la sam, i prihvatam i dajem svoju saglasnost na politiku zaštite privatnosti korisnika i obaveštenje o obradi podataka o ličnosti BioMedica. * <a href="https://www.biomedicazavod.rs/privatnost" target="_blank">{{ translated('clicktoview') }}</a></div>
    </div>
    
    <div class="col-12">
        <div class="checkPay"><Checkbox v-model="checkedPodaci" :binary="true" /></div>
        <div>Garantujem da sam lično, u svojstvu pacijenta, ili kao predstavnik (roditelj/staratelj maloletnog lica ili ovlašćeni predstavnik punoletnog pacijenta) dobrovoljno dostavio gore navedene podatke neophodne za izvršenje zahtevanih laboratorijskih usluga. Garantujem za tačnost istih i prihvatam obavezu da odmah obavestim pružaoca usluga u slučaju pogrešno unetih podataka *</div>
    </div>

    <div class="col-12 imgcredicardrow">
        <div>Podržane platne kartice</div>
        <img alt="logo-platne-kartice" src="@/assets/paymentVisaMaster.png"  height="40">
    </div>    
    
    <div class="col-12 placeholderpaybutton">
        <Button label="PLATI" icon="pi pi-credit-card" @click="submitForm" class="submitbtn" :disabled="!(checkedUslovi && checkedPrivatnost && checkedPodaci)" />
    </div>
</div>

    
    <form id="paymentForm" method="post" action="https://entegrasyon.asseco-see.com.tr/fim/est3Dgate">   
        <input type="hidden" name="clientid" v-model="bankClientId" />
        <input type="hidden" name="amount" v-model="bankAmount" />
        <input type="hidden" name="oid" v-model="transactionId" />
        <input type="hidden" name="okUrl" v-model="bankOkUrl" />
        <input type="hidden" name="failUrl" v-model="bankFailUrl" />
        <input type="hidden" name="islemtipi" v-model="bankTransactionType" />
        <input type="hidden" name="taksit" v-model="bankInstalmentCount" />
        <input type="hidden" name="rnd" v-model="bankRnd" />
        <input type="hidden" name="hash" v-model="bankHash" />
        <input type="hidden" name="currency" v-model="bankCurrency" />
        <input type="hidden" name="storetype" value="3d_pay_hosting" />
        <input type="hidden" name="refreshtime" value="10" />                
    </form>

</template>
  
<script>
import { computed } from "vue"
import createHttp from "@/services/http";
import store from "@/store";
import router from "@/router";
import Spinner from "@/components/Spinner.vue"
import Checkbox from 'primevue/checkbox';

export default {
    components: { Spinner, Checkbox },
    props: ['id','amount', 'otype'],
    data() {
        return {
            translated: computed(() => store.getters.getTranslate),
            isLoading: false,
            bankClientId:"250300000",
            bankAmount:0,
            bankOid:"",
            bankOkUrl:"",
            bankFailUrl:"",
            bankRnd:"",
            bankCurrency: "941",
            bankInstalmentCount: "",
            bankTransactionType: "Auth",
            bankHash: "",
            checkedUslovi: false,
            checkedPrivatnost: false,
            checkedPodaci: false,
            transactionId: ""
        }
    }, 
    async mounted() {
        this.isLoading = true;
        debugger;
        
        const http = createHttp(true);
        
        //this.bankOkUrl = "http://localhost:8080/PaySuccess/" + this.id + "/" + this.otype;
        //this.bankOkUrl = "https://localhost:7020/api/Data/banktransaction";
        this.bankOkUrl = process.env.VUE_APP_API_FOLDER + "/banktransaction";

        // this.bankOkUrl = "http://localhost:1042/3DPayHostingResultPage.aspx";                      //URL which client be redirected if authentication is successful
        //this.bankFailUrl = "https://localhost:7020/api/Data/banktransactionfail";     
        this.bankFailUrl = process.env.VUE_APP_API_FOLDER + "/banktransactionfail";     

        this.bankAmount = this.amount;
        this.bankRnd = new Date().getTime().toLocaleString();
        this.bankOid = this.id;
        this.transactionId = this.generateGUID();

        // console.log(this.id +"////////////////////////////////////////////////////////////////////////////////////////////"); 
        const postData = {
            Tid: this.transactionId,
            Oid : this.bankOid,
            Amount: this.amount.toString(),
            OkURL: this.bankOkUrl,
            FailURL: this.bankFailUrl,
            InstalmentCount: "",
            Rnd: this.bankRnd,
            OType: this.otype
        };

        const resultData = await http.post(process.env.VUE_APP_API_FOLDER + "/getPaymentHash", postData);
        if(resultData.status==200){
            // console.log('PREJEL PODATKE OD SERVERJA ZA getPaymentHash !!!!');
            // console.log(resultData.data);
            this.bankHash = resultData.data;         
        }

        this.isLoading = false;
    },     
    methods: {  
        generateGUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        submitForm() {
            // Perform any pre-submission logic here
            // If everything is fine, submit the form
            debugger;
            this.isLoading = true;
            document.getElementById('paymentForm').submit();
        },
        formatCurrency(amount){
            debugger;
            const amountnumber = parseFloat(amount);
            const formattedAmount = amountnumber.toLocaleString('rs-RS', {
                style: 'currency',
                currency: 'RSD',
            });
            return formattedAmount.replace(/(^\D*)([\d,.]*)(\D*$)/, "$2 $1").trim();
        }
    }  
  };
  </script>
  
  <style scoped>

    .paymetPlaceholder {padding: 100px 50px 300px 50px;background: #f8f9fa;}
    .checkPay {width: 30px;position: relative;float: left;height: 40px;}
    .amountlabel {position: relative;float: left;font-size: 30px;font-weight: bold;}
    .amountnumber {position: relative;float: left;margin-left: 10px;font-size: 30px;font-weight: bold;}
    .col-12.totalValue {margin-bottom: 30px;}
    .imgcredicardrow {margin-top: 30px;}
    .placeholderpaybutton {text-align: center;}

  </style>
  